import ResetConnector from './ResetConnector';

export default ResetConnector;
